import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b2e8d9f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "w-full",
  style: {"overflow":"hidden"}
}
const _hoisted_2 = { class: "w-full min-h-screen" }
const _hoisted_3 = { class: "lg:w-3/4 mx-auto px-4 lg:px-0 mt-32" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-3xl text-gray-900" }, "Waiting list", -1))
const _hoisted_5 = {
  class: "test w-full mt-10 overflow-x-scroll table-auto",
  style: {"display":"block","overflow-x":"auto","white-space":"nowrap"}
}
const _hoisted_6 = {
  class: "font-light border-spacing-4 font-gray-800 text-sm",
  style: {"display":"table","width":"100%"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "bg-mute text-sm text-gray-800 h-10 text-left" }, [
  /*#__PURE__*/_createElementVNode("th", { class: "pl-3 w-20" }, "Name"),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"30%"} }, "Email"),
  /*#__PURE__*/_createElementVNode("th", null, "Status"),
  /*#__PURE__*/_createElementVNode("th", null, "Request"),
  /*#__PURE__*/_createElementVNode("th")
], -1))
const _hoisted_8 = { class: "border-b hover:bg-gray-100" }
const _hoisted_9 = { class: "pl-3 py-3" }
const _hoisted_10 = { class: "pl-3 py-3" }
const _hoisted_11 = { class: "cursor-pointer space-x-4 font-normal text-green-500 items-center py-4" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "7",
  class: "centerData space-x-4 py-4"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-center" }, "No records present")
], -1))
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx, _cache) {
  const _component_vue_element_loading = _resolveComponent("vue-element-loading")
  const _component_HeaderDashboard = _resolveComponent("HeaderDashboard")
  const _component_FooterDashboard = _resolveComponent("FooterDashboard")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_vue_element_loading, {
      active: _ctx.isloading,
      text: "MYLE",
      "text-style": _ctx.loadStyle,
      "is-full-screen": true,
      class: "h-full background-overlay",
      spinner: "bar-fade-scale",
      color: "#ffffff"
    }, null, 8, ["active", "text-style"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_HeaderDashboard),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("table", _hoisted_5, [
            _createElementVNode("tbody", _hoisted_6, [
              _hoisted_7,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (rec) => {
                return (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                  _createElementVNode("td", _hoisted_9, [
                    _createElementVNode("p", null, _toDisplayString(rec.name), 1)
                  ]),
                  _createElementVNode("td", _hoisted_10, [
                    _createElementVNode("p", null, _toDisplayString(rec.email), 1)
                  ]),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(rec.status), 1),
                  _createElementVNode("td", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((rec.requestDescription || '').split('\n'), (x) => {
                      return (_openBlock(), _createElementBlock("div", null, _toDisplayString(x), 1))
                    }), 256))
                  ]),
                  _createElementVNode("td", null, [
                    (rec.status == 'WAITING')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: $event => (_ctx.approve(rec.waitingListId)),
                          class: "close mt-3 px-2 py-2 text-sm text-white rounded-full bg-green-500 hover:bg-green-600 transition duration-300 ease-in-out"
                        }, " Approve Request ", 8, _hoisted_12))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 256)),
              (_ctx.list.length <= 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_13, _hoisted_15))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createVNode(_component_FooterDashboard)
    ])
  ], 64))
}